const admin = {
    "resources": {
        "activities": {
            "name": "Activities",
            "fields": {
                "is_public": "Is Public",
                "is_highlight": "Is Highlight",
                "is_payment": "Is Payment",
                "position": "Position",
                "start_date": "Start Date",
                "end_date": "End Date",
                "display_on_mon": "Display On Mon",
                "display_on_tue": "Display On Tue",
                "display_on_wed": "Display On Wed",
                "display_on_thu": "Display On Thu",
                "display_on_fri": "Display On Fri",
                "display_on_sat": "Display On Sat",
                "display_on_sun": "Display On Sun",
                "direct_link_en": "Direct Link En",
                "direct_link_tc": "Direct Link Tc",
                "direct_link_sc": "Direct Link Sc",
                "direct_link_type": "Direct Link Type",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "short_title_en": "Short Title En",
                "short_title_tc": "Short Title Tc",
                "short_title_sc": "Short Title Sc",
                "activity_category_id": "Activity Category",
                "image_fm": "Image Fm",
                "image_1_fm": "Image 1 Fm",
                "image_2_fm": "Image 2 Fm",
                "short_description_en_html": "Short Description En Html",
                "short_description_tc_html": "Short Description Tc Html",
                "short_description_sc_html": "Short Description Sc Html",
                "description_en_html": "Description En Html",
                "description_tc_html": "Description Tc Html",
                "description_sc_html": "Description Sc Html",
                "show_application_button": "Show Application Button",
                "application_form_id": "Application Form"
            }
        },
        "application_form": {
            "name": "Application Form",
            "fields": []
        },
        "og_redirect": {
            "name": "Redirect Links",
            "fields": {
              "og_image_fm": "Thumbnail",
            },
        },
        "audio": {
            "name": "Audio",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "audio_sub_category_id": "Audio Sub Category",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "audio_link": "Audio Link",
                "audio_duration": "Audio Duration"
            }
        },
        "book": {
            "name": "Book",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "description_en": "Description En",
                "description_tc": "Description Tc",
                "description_sc": "Description Sc",
                "thumbnail_fm": "Thumbnail Fm"
            }
        },
        "channel": {
            "name": "Channel",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "channel_sub_category_id": "Channel Sub Category",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "link": "Link",
                "link_cn": "Link Cn",
                "thumbnail_fm": "Thumbnail Fm"
            }
        },
        "content_node": {
            "name": "Content Node",
            "fields": {
                "is_public": "Is Public",
                "tree_node_parent_id": "Tree Node Parent",
                "tree_node_parent_order": "Tree Node Parent Order",
                "tree_node_alias": "Tree Node Alias",
                "url_path": "Url Path",
                "content_type": "Content Type",
                "content_type_data": "Content Type Data",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "body_class": "Body Class",
                "template_alias": "Template Alias",
                "content_data": "Content Data",
                "mobile_section_image": "Mobile Section Image",
                "image_array": "Image Array",
                "image_caption_array": "Image Caption Array"
            }
        },
        "donation": {
            "name": "Donation",
            "fields": {
                "type": "Type",
                "invoice_number": "Invoice Number",
                "status": "Status",
                "amount": "Amount",
                "personal_team": "Personal Team",
                "name": "Name",
                "contact_person": "Contact Person",
                "salutarion": "Salutarion",
                "contact_person_tel": "Contact Person Tel",
                "email": "Email",
                "payment_method": "Payment Method",
                "credit_card": "Credit Card",
                "plan_purpose": "Plan Purpose",
                "general_method": "General Method",
                "general_purpose": "General Purpose",
                "general_purpose_2": "General Purpose 2",
                "receipt": "Receipt",
                "receipt_title": "Receipt Title",
                "receipt_method": "Receipt Method"
            }
        },
        "email_log": {
            "name": "Email Log",
            "fields": {
                "user_id": "User",
                "email_template_id": "Email Template",
                "to_name": "To Name",
                "to_email": "To Email",
                "cc_email_array": "Cc Email Array",
                "bcc_email_array": "Bcc Email Array",
                "subject": "Subject",
                "content_html": "Content Html",
                "status": "Status"
            }
        },
        "email_template": {
            "name": "Email Template",
            "fields": {
                "alias": "Alias",
                "title": "Title",
                "subject_en": "Subject En",
                "subject_tc": "Subject Tc",
                "subject_sc": "Subject Sc",
                "content_en_html": "Content En Html",
                "content_tc_html": "Content Tc Html",
                "content_sc_html": "Content Sc Html",
                "footer_type": "Footer Type",
                "footer_en_html": "Footer En Html",
                "footer_tc_html": "Footer Tc Html",
                "footer_sc_html": "Footer Sc Html",
                "active_status": "Active Status",
                "sender_name": "Sender Name",
                "sender_email": "Sender Email",
                "reply_to_email": "Reply To Email",
                "cc_email_type": "Cc Email Type",
                "cc_email_array": "Cc Email Array",
                "bcc_email_type": "Bcc Email Type",
                "bcc_email_array": "Bcc Email Array"
            }
        },
        "highlight": {
            "name": "Highlight",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "highlight_sub_category_id": "Highlight Sub Category",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "sub_title_en": "Sub Title En",
                "sub_title_tc": "Sub Title Tc",
                "sub_title_sc": "Sub Title Sc",
                "description_en": "Description En",
                "description_tc": "Description Tc",
                "description_sc": "Description Sc",
                "speaker_en": "Speaker En",
                "speaker_tc": "Speaker Tc",
                "speaker_sc": "Speaker Sc",
                "address_en": "Address En",
                "address_tc": "Address Tc",
                "address_sc": "Address Sc",
                "display_date": "Display Date",
                "thumbnail_fm": "Thumbnail Fm",
                "cover_image_fm": "Cover Image Fm",
                "video_link": "Video Link",
                "video_link_cn": "Video Link Cn"
            }
        },
        "opinion": {
            "name": "Opinion",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "question_category_id": "Question Category",
                "name": "Name",
                "title": "Title",
                "contact": "Contact",
                "email": "Email",
                "about": "About",
                "message": "Message"
            }
        },
        "option": {
            "name": "Option",
            "fields": {
                "is_public": "Is Public",
                "tree_node_parent_id": "Tree Node Parent",
                "tree_node_parent_order": "Tree Node Parent Order",
                "option_type": "Option Type",
                "name_en": "Name En",
                "name_tc": "Name Tc",
                "name_sc": "Name Sc",
                "desc_en": "Desc En",
                "desc_tc": "Desc Tc",
                "desc_sc": "Desc Sc"
            }
        },
        "questions": {
            "name": "Questions",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "question_category_id": "Question Category",
                "name": "Name",
                "title": "Title",
                "contact": "Contact",
                "email": "Email",
                "question_en": "Question En",
                "question_tc": "Question Tc",
                "question_sc": "Question Sc",
                "answer_en": "Answer En",
                "answer_tc": "Answer Tc",
                "answer_sc": "Answer Sc"
            }
        },
        "reading": {
            "name": "Reading",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "reading_sub_category_id": "Reading Sub Category",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "description_en": "Description En",
                "description_tc": "Description Tc",
                "description_sc": "Description Sc",
                "journal_en": "Journal En",
                "journal_tc": "Journal Tc",
                "journal_sc": "Journal Sc"
            }
        },
        "sharing_others": {
            "name": "Sharing Others",
            "fields": {
                "is_public": "Is Public",
                "position": "Position",
                "sharing_others_category_id": "Sharing Others Category",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc",
                "display_date": "Display Date",
                "link": "Link",
                "link_cn": "Link Cn",
                "cover_image_fm": "Cover Image Fm",
                "click_image": "Click Image",
                "description": "Description"
            }
        },
        "site_config": {
            "name": "Site Config",
            "fields": {
                "is_public": "Is Public",
                "title_en": "Title En",
                "title_tc": "Title Tc",
                "title_sc": "Title Sc"
            }
        },
        "volunteer": {
            "name": "Volunteer",
            "fields": {
                "last_name": "Last Name",
                "first_name": "First Name",
                "chinese_last_name": "Chinese Last Name",
                "chinese_first_name": "Chinese First Name",
                "gender": "Gender",
                "year_birth": "Year Birth",
                "identity": "Identity",
                "working_status": "Working Status",
                "other_career": "Other Career",
                "address": "Address",
                "faith": "Faith",
                "other_faith": "Other Faith",
                "leading": "Leading",
                "education": "Education",
                "other_education": "Other Education",
                "language_cantonese": "Language Cantonese",
                "language_mandarin": "Language Mandarin",
                "language_english": "Language English",
                "others": "Others",
                "other_language": "Other Language",
                "skill_instrument": "Skill Instrument",
                "skill_translation": "Skill Translation",
                "skill_computer": "Skill Computer",
                "skill_photography": "Skill Photography",
                "skill_drive": "Skill Drive",
                "skill_others": "Skill Others",
                "other_skill": "Other Skill",
                "service_hospital_visit": "Service Hospital Visit",
                "service_visiting_homes": "Service Visiting Homes",
                "service_center_cleaning": "Service Center Cleaning",
                "service_photography": "Service Photography",
                "service_others": "Service Others",
                "other_service": "Other Service",
                "experience": "Experience",
                "other_experience": "Other Experience",
                "disease_heart_disease": "Disease Heart Disease",
                "disease_hypertension": "Disease Hypertension",
                "disease_epilepsy": "Disease Epilepsy",
                "disease_diabetes": "Disease Diabetes",
                "disease_tuberculosis": "Disease Tuberculosis",
                "disease_hepatitis": "Disease Hepatitis",
                "disease_others": "Disease Others",
                "other_disease": "Other Disease",
                "emotional_disorder": "Emotional Disorder",
                "emotional_status": "Emotional Status",
                "contact_person": "Contact Person",
                "relationship": "Relationship",
                "contact_person_tel": "Contact Person Tel",
                "agreement_1": "Agreement 1",
                "agreement_2": "Agreement 2"
            }
        }
    }
}

export default admin;
